function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { createURL } from '@sm/utils';
import { t, defineMessages } from '@sm/intl';
var COPY = defineMessages({
  MY_ACCOUNT: {
    id: 'getUserLinks.myAccount',
    defaultMessage: 'My Account',
    description: '[Type: Label][Vis.: high] - This is the My account dropdown on the header.'
  },
  SWITCH_ACCOUNTS: {
    id: 'getUserLinks.switchAccount',
    defaultMessage: 'Switch accounts',
    description: '[Type: Label][Vis.: high] - This is the Switch accounts link in the user dropdown.'
  },
  MY_TEAM: {
    id: 'getUserLinks.myTeam',
    defaultMessage: 'My Team',
    description: '[Type: Label][Vis.: high] - This is the My teams section of the userdrop down.'
  },
  LIBRARY: {
    id: 'getUserLinks.library',
    defaultMessage: 'Library',
    description: '[Type: Label][Vis.: high] - This is the Library link in the userdrop down.'
  },
  CONTACTS: {
    id: 'getUserLinks.contacts',
    defaultMessage: 'Contacts',
    description: '[Type: Label][Vis.: high] - This is the contacts link in the userdrop down.'
  },
  BENCHMARKS: {
    id: 'getUserLinks.benchmarks',
    defaultMessage: 'Benchmarks',
    description: '[Type: Label][Vis.: high] - This is the benchmarks link in the userdrop down.'
  },
  SIGN_OUT: {
    id: 'getUserLinks.sign_out',
    defaultMessage: 'Sign Out',
    description: '[Type: Label][Vis.: high] - This is the sign out link in the userdrop down.'
  }
});
var getUserLinks = function getUserLinks(isNonEnterpriseGroupAdmin, paidBenchmarksEnabled, libraryEnabled, plansBenchmarksEnabled, isEnterpriseAccount, lang, isEUDC, hasMultipleLinkedIdentities) {
  var userLinks = [{
    path: createURL('/user/account/', {
      ut_source: 'header'
    }),
    name: t(COPY.MY_ACCOUNT),
    navItem: 'my account'
  }].concat(_toConsumableArray(hasMultipleLinkedIdentities ? [{
    path: createURL('/user/account/select/', {
      ut_source: 'header',
      ep: window && "".concat(window.location.pathname).concat(window.location.search)
    }),
    name: t(COPY.SWITCH_ACCOUNTS),
    navItem: 'switch accounts'
  }] : []), _toConsumableArray(isNonEnterpriseGroupAdmin ? [{
    path: createURL('/team', {
      ut_source: 'header'
    }),
    name: t(COPY.MY_TEAM),
    navItem: 'my team'
  }] : []), _toConsumableArray(!isEnterpriseAccount && libraryEnabled ? [{
    path: createURL('/team/libraries', {
      ut_source: 'header'
    }),
    name: t(COPY.LIBRARY),
    navItem: 'library'
  }] : []), [{
    path: createURL('/addressbook/', {
      ut_source: 'header'
    }),
    name: t(COPY.CONTACTS),
    navItem: 'contacts'
  }], _toConsumableArray((lang === 'en' && plansBenchmarksEnabled || paidBenchmarksEnabled) && !isEUDC ? [{
    path: createURL('/benchmarks/home/', {
      ut_source: 'header_username_menu',
      ut_source2: 'wide_menu'
    }),
    name: t(COPY.BENCHMARKS),
    navItem: 'benchmarks'
  }] : []), [{
    path: createURL('/user/sign-out/', {
      ut_source: 'header'
    }),
    name: t(COPY.SIGN_OUT),
    navItem: 'sign out'
  }]);
  return userLinks;
};
export default getUserLinks;
//# sourceMappingURL=getUserLinks.js.map